module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noind",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('a', {
    attrs: {
      "id": "start"
    }
  }, [_c('i', [_vm._v("Dawn like’ a thousand shining spears")])])]), _c('a', {
    attrs: {
      "id": "start"
    }
  }, [_c('p', {
    staticClass: "noind"
  }, [_c('i', [_vm._v("Terrible in the east appears;")])]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('i', [_vm._v("Hide me, you leaves of lovely gloom")])]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('i', [_vm._v("Where the young dreams like lilies bloom.")])]), _vm._v(" "), _c('p', {
    staticClass: "poem3",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('i', [_vm._v("In vain I turn aside to where")])]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_c('i', [_vm._v("Stars made a palace of the air;")])]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_c('i', [_vm._v("In vain I hide my face away")])]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_c('i', [_vm._v("From the too bright invading day.")])]), _vm._v(" "), _c('p', {
    staticClass: "poem3",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('i', [_vm._v("That which is come requires of me")])]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_c('i', [_vm._v("My utter truth and mystery.")])]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_c('i', [_vm._v("Return, you dreams, return to night")])]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_c('i', [_vm._v("My lover is the armed light.")])]), _vm._v(" "), _c('p', {
    staticClass: "right",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("LAURENCE BINYON")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78d4b0a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/4epigraph.vue
// module id = 72
// module chunks = 0